export default __webpack_public_path__ + "static/media/instagram.531889b0.svg";